import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetErpItemPricesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ErpItemPricingDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ErpItemPricingDocumentSortInput> | Types.ErpItemPricingDocumentSortInput>;
}>;


export type GetErpItemPricesQuery = { __typename?: 'Query', erpItemPrices: Array<{ __typename?: 'ErpItemPricingDocument', erpItemId: string, erpItemPricingId: string, erpPriceGroupId: string, unitPrice: number, containerQuantity: number, startDate: Types.TDateISO, endDate: Types.TDateISO, tenantId: string }> };

export type GetErpItemPricingQueryVariables = Types.Exact<{
  erpPriceGroupId: Types.Scalars['String']['input'];
  startYear: Types.Scalars['Int']['input'];
}>;


export type GetErpItemPricingQuery = { __typename?: 'Query', erpItemPricing?: { __typename?: 'ErpItemPricingStateData', erpPriceGroupId: string, tenantId: string, startYear: number, itemPrices: Array<{ __typename?: 'ErpItemPriceData', erpItemId: string, unitPrice: number, containerQuantity: number, startDate: Types.TDateISO, endDate: Types.TDateISO }> } | null };


export const GetErpItemPricesDocument = new TypedDocumentString(`
    query GetErpItemPrices($where: ErpItemPricingDocumentFilterInput, $order: [ErpItemPricingDocumentSortInput!]) {
  erpItemPrices(where: $where, order: $order) {
    erpItemId
    erpItemPricingId
    erpPriceGroupId
    unitPrice
    containerQuantity
    startDate
    endDate
    tenantId
  }
}
    `);
export const GetErpItemPricingDocument = new TypedDocumentString(`
    query GetErpItemPricing($erpPriceGroupId: String!, $startYear: Int!) {
  erpItemPricing(erpPriceGroupId: $erpPriceGroupId, startYear: $startYear) {
    erpPriceGroupId
    tenantId
    startYear
    itemPrices {
      erpItemId
      unitPrice
      containerQuantity
      startDate
      endDate
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetErpItemPrices: build.query<GetErpItemPricesQuery, GetErpItemPricesQueryVariables | void>({
      query: (variables) => ({ document: GetErpItemPricesDocument, variables })
    }),
    GetErpItemPricing: build.query<GetErpItemPricingQuery, GetErpItemPricingQueryVariables>({
      query: (variables) => ({ document: GetErpItemPricingDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetErpItemPricesQuery, useLazyGetErpItemPricesQuery, useGetErpItemPricingQuery, useLazyGetErpItemPricingQuery } = injectedRtkApi;
